<template>
  <b-modal id="modalCustomers" size="lg" :title="customer.projectName">
    <div class="row">
      <div style="position:relative" class="col-lg-12">
        <img
          class="card-img-top"
          :src="customer.logo"
          alt
        />
        <p class="project-year">Project Year : {{ customer.year }}</p>
        <p class="proj-desc">Project Description:</p>
        <p>
          {{ customer.description }}
        </p>
        <div class="client-info">
          <p>Customer:</p>
          <img
            :src="customer.logo"
          />
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import miscAPI from "@/api/misc";
export default {
  props: ["customer"],
  data() {
    return {};
  },
  computed: {
    account() {
      let data = this.$store.state.account.account;

      if (data && data.type == "user") data.detail = data.user;
      else if (data && data.type == "shipyard") data.detail = data.shipyard;
      else if (data && data.type == "vendor") data.detail = data.vendor;

      return data;
    }
  },
  methods: {}
};
</script>

<style lang="scss">
@import "~/assets/scss/_mixins.scss";
@import "./style.scss";
</style>
